import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';


@Component({
    selector: 'eas-editor-booking-item-option-summary',
    templateUrl: './editor-booking-item-option-summary.component.html',
    styleUrls: ['./editor-booking-item-option-summary.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemOptionSummaryComponent implements OnInit {
  @Input() itemOption: EditorBookingItem;

  constructor() {

  }

  ngOnInit() {

  }
}
